import type { StoryblokRichTextNode } from "@storyblok/react";
import type { ReactElement } from "react";
import GridItem from "../../components/general/GridItem";
import RichText from "../../components/general/RichText";

const RichtextContainerModule = ({
	richtext,
	centered_text,
}: Queries.RichtextContainerModuleFragment) => (
	<GridItem>
		{richtext && (
			<RichText
				content={richtext as StoryblokRichTextNode<ReactElement>}
				centeredText={centered_text}
			/>
		)}
	</GridItem>
);
export default RichtextContainerModule;
